import { useOutletContext } from 'react-router-dom'
import type { RotinaApi } from 'service/api'

export function useRotinasOutletContext() {
    return useOutletContext<{
        data?: RotinaApi[]
    }>()
}
